import { Component } from '@angular/core';

@Component({
  selector: 'app-hipaa',
  imports: [],
  templateUrl: './hipaa.html',
  styleUrl: './hipaa.css',
})
export class Hipaa {
  features = [
    {
      icon: '🏥',
      title: 'PHI Protection',
      description: 'Secure protected health information with encryption, access controls, and comprehensive security measures.'
    },
    {
      icon: '📋',
      title: 'Privacy Rule Compliance',
      description: 'Implement privacy policies and procedures to protect patient health information rights.'
    },
    {
      icon: '🔐',
      title: 'Security Rule Implementation',
      description: 'Deploy administrative, physical, and technical safeguards required by HIPAA Security Rule.'
    },
    {
      icon: '📝',
      title: 'BAA Management',
      description: 'Comprehensive Business Associate Agreement management and vendor compliance oversight.'
    },
    {
      icon: '🔍',
      title: 'Risk Analysis',
      description: 'Thorough risk assessments identifying vulnerabilities and threats to ePHI confidentiality and integrity.'
    },
    {
      icon: '📊',
      title: 'Breach Response',
      description: 'Incident response planning and breach notification procedures compliant with HIPAA requirements.'
    }
  ];

  process = [
    {
      number: 1,
      title: 'Risk Assessment',
      description: 'Comprehensive analysis of PHI handling, storage, and transmission to identify compliance gaps.'
    },
    {
      number: 2,
      title: 'Policy & Procedures',
      description: 'Develop HIPAA-compliant policies, privacy practices, and security procedures.'
    },
    {
      number: 3,
      title: 'Technical Safeguards',
      description: 'Implement encryption, access controls, audit logging, and security monitoring systems.'
    },
    {
      number: 4,
      title: 'Training & Validation',
      description: 'Staff training programs and ongoing compliance monitoring to maintain HIPAA adherence.'
    }
  ];

  caseStudy = {
    title: 'Telemedicine Platform Achieves Full HIPAA Compliance',
    description: 'A growing telemedicine platform serving 200,000+ patients needed comprehensive HIPAA compliance to expand services and partner with healthcare providers.',
    challenge: 'Cloud infrastructure without proper PHI safeguards, insufficient access controls, and no formal compliance program',
    solution: 'End-to-end HIPAA compliance framework including infrastructure hardening, policy development, and staff training',
    industry: 'Telemedicine',
    timeline: '8 Months',
    result: '10x Growth'
  };

  testimonial = {
    quote: 'HoneyKode expertise in HIPAA compliance was invaluable. They helped us build a secure, compliant platform that patients and providers trust. Their guidance went beyond checkboxes to create genuine security culture.',
    author: 'Dr. Marcus Thompson',
    role: 'Chief Medical Officer, VirtualCare Health'
  };
}
